module.exports = __webpack_public_path__ + "static/media/pir-1.469936ad.png";